import { render, staticRenderFns } from "./question-answer-section.vue?vue&type=template&id=78119afe&"
import script from "./question-answer-section.vue?vue&type=script&lang=js&"
export * from "./question-answer-section.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports